import { render, staticRenderFns } from "./administratorDetail.vue?vue&type=template&id=219a06ac&scoped=true&"
import script from "./administratorDetail.vue?vue&type=script&lang=js&"
export * from "./administratorDetail.vue?vue&type=script&lang=js&"
import style0 from "./administratorDetail.vue?vue&type=style&index=0&id=219a06ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219a06ac",
  null
  
)

export default component.exports